import { render, staticRenderFns } from "./DietaryNeeds.vue?vue&type=template&id=35721812&"
import script from "./DietaryNeeds.vue?vue&type=script&lang=js&"
export * from "./DietaryNeeds.vue?vue&type=script&lang=js&"
import style0 from "./DietaryNeeds.vue?vue&type=style&index=0&id=35721812&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports